import {
  MaterialReactTable,
  useMaterialReactTable,
  type MRT_TableOptions,
} from "material-react-table";
import type { AdminCampaignDto } from "Infrastructure/Api/Api";
import { useTableLocalization } from "Utils/TableLocalizationUtils";
import { useMemo } from "react";
import { useResource } from "Translations/Resources";
import { createColumns } from "Components/Admin/Campaigns/DeletedCampaignListTable/columns";

type Props = {
  data: Array<AdminCampaignDto>;
  isLoading: boolean;
  isRefetching: boolean;
  onRestore: (id: number) => void;
  rowCount?: number;
  tableProps?: Partial<MRT_TableOptions<AdminCampaignDto>>;
};

export const DeletedCampaignsTable = ({
  data,
  isLoading,
  isRefetching,
  onRestore,
  rowCount,
  tableProps,
}: Props) => {
  const { t } = useResource();
  const localization = useTableLocalization();
  const columns = useMemo(() => createColumns(t, onRestore), [t, onRestore]);
  const table = useMaterialReactTable({
    ...tableProps,
    data,
    columns,
    rowCount,
    enableColumnResizing: true,
    columnResizeMode: "onChange",
    localization,
    state: {
      ...tableProps?.state,
      isLoading,
      showProgressBars: isRefetching,
    },
    initialState: {
      density: "compact",
    },
    muiTablePaperProps: {
      sx: { borderRadius: "10px" },
    },
  });

  return <MaterialReactTable table={table} />;
};
